export default {
  locations: [],
  locationsFix: [],
  locationsROI: [],
  isVisible: true,
  selectedLocation: {},
  locationId: null,
  selectLocationModal: false,
  dateRange: {},
  locationsGroup: [],
  locationsGroupFromDate: [],
  locationByGroupItem: [],
  createDialogVisible: false,
  locationGroupId: 0
};
